// frontend\src\components\LanguageToggle.jsx
import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../context/LanguageContext';
import { FaLanguage } from 'react-icons/fa'; // استيراد الأيقونة

const ToggleButton = styled.button`
  position: fixed;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 3.5rem;
  padding: 0.5rem 0.5rem;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem; // المسافة بين الأيقونة والنص
  z-index: 10000;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  // يمكن تعديل حجم الأيقونة والنص بشكل منفصل إذا لزم الأمر
  svg {
    font-size: 1.1rem; // حجم الأيقونة
  }
  span {
    font-weight: bold;
    font-size: 0.9rem; // حجم النص
  }
`;

const LanguageToggle = () => {
  const { isArabic, setIsArabic } = useLanguage();

  return (
    <ToggleButton onClick={() => setIsArabic(!isArabic)}>
      <FaLanguage />
      {/* عرض اللغة التي سيتم التحويل إليها أو الحالية */}
      <span>{isArabic ? 'EN' : 'AR'}</span>
    </ToggleButton>
  );
};

export default LanguageToggle;